<template>
  <div class="fullheight-lead">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="container">
        <div class="navbar-brand">
          <a class="navbar-item" style="padding-top: 10px">
            <img
              src="../../src/assets/img/cardiff-white-text-only.png"
              id="logo"
              height="28"
            />
          </a>
        </div>
      </div>
    </nav>
    <div class="container is-fluid fullheight-lead" id="appcontainer">
      <div class="columns fullheight-lead is-centered">
        <div class="column" id="app-column-lead">
          <transition name="slide" mode="out-in">
            <VerifyBankLeadLoading
              v-if="page == 0"
              key="p0"
              @next="incrementPage"
              :link="$route.params.code"
            />
            <VerifyBankLeadVerification
              v-if="page == 1"
              key="p1"
              @next="incrementPage"
              message="To speed up the funding process, we use bank verification to automatically process your loan. You'll be asked to select your bank and enter your online banking credentials through our secure portal.<br><br>Please use your <strong>business bank account</strong>, personal accounts are not accepted."
            />
            <Plaid
              v-if="page == 2"
              key="p2"
              @next="incrementPage"
              api="plaid-lead-journey"
              :link="$route.params.code"
              redirect_url="lead_plaid"
            />
            <VerifyBankLeadFinish
              v-if="page == 3"
              key="p3"
              @next="incrementPage"
              :item_id="item_id"
              @back="page--"
            />
          </transition>
        </div>
      </div>
    </div>
    <footer class="footer" style="margin-top: 60px" v-if="page != 7">
      <div class="content has-text-centered">
        <img
          src="../../src/assets/img/bbb.svg"
          style="margin-left: 15px; max-width: 120px"
        />
        <img
          src="../../src/assets/img/ssl.svg"
          style="margin-left: 15px; max-width: 120px; margin-right: 15px"
        />
        <p style="font-size: 0.675em; color: grey; margin-top: 10px">
          © 2024 Cardiff, Inc
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
function setWithExpiry(key, value, ttl) {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}
import {
  VerifyBankLeadLoading,
  VerifyBankLeadVerification,
  Plaid,
  VerifyBankLeadFinish,
} from "@/components/apply/pages";
import { build } from "@/tools/modelBuilder";
export default {
  name: "VerifyBankOldOpportunity",
  components: {
    // BankVerify,
    VerifyBankLeadLoading,
    Plaid,
    VerifyBankLeadVerification,
    VerifyBankLeadFinish,
  },
  data() {
    return {
      page: 0,
      demo: false,
      customerId: null,
      model: { name: "" },
      maxPage: 4,
      item_id: null,
      scrolled: false,
      loading: false,
      plaid: null,
      finresult: true,
    };
  },
  methods: {
    incrementPage: function (pageData) {
      console.log("page:", this.page);
      var self = this;
      console.log(pageData);
      this.validate();
      build(this.model, pageData);
      if (pageData.customerId) {
        console.log("we have the customer id ", pageData.customerId);
        this.customerId = pageData.customerId;
      }
      if (this.page == 0) {
        // setWithExpiry("leadid", "", 1);
        console.log("page 0, before it deleted the leadid");
      }
      if (this.page == 1) {
        console.log("loading plaid:");
        console.log(self.model);
        //create the lead
        //get the leadid
        $.ajax({
          type: "POST",
          url: "/api/bank-verification/lead_journey_load_plaid",
          contentType: "application/json",
          dataType: "json",
          data: JSON.stringify({
            model: self.model,
          }),
        })
          .done(function (response) {
            console.log(response);
            if (response.leadid) {
              console.log("setting leadid in model", response.leadid);
              self.model.sfleadid = response.leadid;
              //save to local storage
              setWithExpiry("leadid", response.leadid, 259200);
            }
          })
          .fail(function (err) {
            console.log(err.responseText);
            self.invalid = true;
          });
      }
      if (pageData.item_id) {
        self.item_id = pageData.item_id;
        self.plaid = {
          item_id: pageData.item_id,
          access_token: pageData.access_token,
        };

        $.ajax({
          type: "POST",
          url: "/api/bank-verification/completed_plaid_lead",
          contentType: "application/json",
          dataType: "json",
          data: JSON.stringify({
            model: self.model,
          }),
        })
          .done(function (response) {
            console.log(response);
            //   if (response.leadid) {
            //     console.log("setting leadid in model", response.leadid);
            //     self.model.sfleadid = response.leadid;
            //     //save to local storage
            //     setWithExpiry("leadid", response.leadid, 259200);
            //   }
          })
          .fail(function (err) {
            console.log(err.responseText);
            self.invalid = true;
          });
      }
      this.page++;
      window.scrollTo(0, 0);
    },
    validate: function () {
      console.log(this.$route.params.code);
    },
  },
  mounted: function () {
    console.log("mounted verify bank lead");
    let self = this;
    // if (!this.demo) {
    //   return;
    // }
    // const self = this;
    // setInterval(function () {
    //   if (self.page === 1) {
    //     self.page += 2;
    //   } else if (self.page === 6 || self.page === 3) {
    //     self.page += 3;
    //   } else if (self.page < 9) {
    //     self.page++;
    //   }
    // }, 3000);
    // console.log("params:");
    // console.log(self.$route.params);
    // console.log("code:");
    // console.log(self.$route.params.code);

    // console.log("query utm:");
    // console.log(self.$route.query);

    self.model.medium = "";
    self.model.template = "";
    self.model.cta = "";
    self.model.source = "";
    self.model.campaign = "";

    let url_query = "";
    if (self.$route.query && self.$route.query != "") {
      url_query = self.$route.query;
    }
    console.log("url query:" + url_query);
    // Marketing Cloud URLs
    // utm_term - string //could have the CTA included
    // utm_medium - array

    //if the template code is not in the CTA we use the email name instead to know
    // if (
    //   url_query &&
    //   url_query.utm_campaign &&
    //   url_query.utm_campaign.length > 0
    // ) {
    //   self.model.template = url_query.utm_campaign[0];
    // }

    // if (url_query && url_query.utm_term && url_query.utm_term !== "") {
    //   // if there is - explode it and first part will be the template and second part will be the cta name
    //   let term = url_query.utm_term;
    //   self.model.cta = term; //default
    //   let position = term.search("-");
    //   if (position >= 0) {
    //     let separated = term.split("-");
    //     self.model.cta = separated[0];
    //     self.model.template = separated[1];
    //   }
    // }
    if (
      url_query &&
      url_query.utm_medium &&
      url_query.utm_medium.length !== 0
    ) {
      self.model.medium = url_query.utm_medium[0];
    }
    if (
      url_query &&
      url_query.utm_medium &&
      url_query.utm_medium.length !== 0
    ) {
      self.model.medium = url_query.utm_medium[0];
    }
    // attentive UTMS
    if (
      url_query &&
      url_query.utm_campaign &&
      url_query.utm_campaign.length !== 0
    ) {
      self.model.campaign = url_query.utm_campaign;
    }
    if (
      url_query &&
      url_query.utm_medium &&
      url_query.utm_medium.length !== 0
    ) {
      self.model.medium = url_query.utm_medium;
    }
    if (
      url_query &&
      url_query.utm_source &&
      url_query.utm_source.length !== 0
    ) {
      self.model.source = url_query.utm_source;
    }
    
    // utm_campaign=RenewalLink&utm_medium=email&utm_source=attentive

    //our custom URLs

    // if (url_query && url_query.m && url_query.m !== "") {
    //   self.model.medium = url_query.m == "e" ? "email" : "sms";
    // }

    // if (url_query && url_query.t && url_query.t !== "") {
    //   self.model.template = url_query.t;
    // }

    // if (url_query && url_query.cta && url_query.cta !== "") {
    //   self.model.cta = url_query.cta;
    // }
    console.log(self.model);

    if (
      self.$route.params &&
      self.$route.params.code &&
      self.$route.params.code != "oauth"
    ) {
      setWithExpiry("leadid", self.$route.params.code, 259200);
      setWithExpiry("oauth_state_id", "", 10);
    }

    const leadid = getWithExpiry("leadid");

    if (
      self.$route.query &&
      self.$route.query.oauth_state_id &&
      self.$route.query.oauth_state_id !== ""
    ) {
      setWithExpiry("oauth_state_id", self.$route.query.oauth_state_id, 259200);
    }

    if (leadid) {
      self.model.sfleadid = leadid;
    }
    let oauth_token = getWithExpiry("oauth_state_id");
    console.log("oauth token:" + oauth_token);
    if (oauth_token && oauth_token !== "") {
      console.log("found oauth token! ");
      //when we have oauth token the user came from a redirection from the bank website
      self.page = 2;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar .navbar-brand {
  text-align: center;
  display: block;
  width: 100%;
}

.navbar .navbar-brand > .navbar-item,
.navbar .navbar-brand .navbar-link {
  display: inline-block;
}
@media screen and (min-width: 767px), print {
  .mobile-only {
    display: none;
  }
  .fullheight-lead {
    height: 100%;
  }
  #app-column-lead {
    padding: 50px 120px;
  }
}

@media screen and (max-width: 768px) {
  #cardiff-column {
    display: none;
  }
  #app-column-lead {
    min-height: 100vh;
    padding-top: 50px;
  }
}

#cardiff-column {
  background: #f1f1f1;
  z-index: 1;
  padding-top: 100px;
  max-width: 280px;
}

#logo {
  /* max-width: 50%; */
  margin: auto;
  display: block;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
}

.next-button {
  margin-top: 10px;
}

.columns {
  margin-left: 0;
  margin-right: 0;
}

.no-margin {
  margin-bottom: 0px !important;
}
</style>
